module.exports = __webpack_public_path__ + "img/016.17f50087.png";